module.exports = __webpack_public_path__ + "img/image-schedule2023.9b99cc79.jpg";